<template>
  <form class="p-3" @submit.prevent="validar">
    <div class="row">
      <div class="form-group col-md-4 col-12">
        <label><i class="fa fa-asterisk text-danger"></i>Tipo pasivo</label>
        <combo-box
            v-model="datos.tipoPasivo"
            :opciones="lstTipoPasivo"
            :valid="errors.has('tipo Pasivo')"
            name="tipo Pasivo"
            v-validate="{required:true,obj:true}"
        ></combo-box>
        <span class="form-text text-danger">{{ errors.first("tipo Pasivo") }}</span>
      </div>
      <div class="form-group col-md-4 col-12">
        <label for="observacióndp"><i class="fa fa-asterisk text-danger"></i>Observación del pasivo</label>
        <input
            type="text"
            class="form-control"
            :class="errors.has('observación del pasivo') && 'is-invalid'"
            v-model="datos.obs"
            name="observación del pasivo"
            id="observacióndp"
            v-validate="{required:true}"
        >
        <span class="form-text text-danger">{{ errors.first("observación del pasivo") }}</span>
      </div>
      <div class="form-group col-md-4 col-12">
        <label for="valor"><i class="fa fa-asterisk text-danger"></i>Valor de pasivo</label>
        <input
            type="number"
            class="form-control"
            :class="errors.has('valor') && 'is-invalid'"
            v-model="datos.cantidad"
            name="valor"
            id="valor"
            min="1" step="any"
            v-validate="{decimal:2,required:true,min_value:1}"
        >
        <span class="form-text text-danger">{{ errors.first("valor") }}</span>
      </div>
      <div class="col-12 col-md-12 p-1">
        <div class="col-12 col-md-4 p-1">
          <button type="submit" class="btn btn-success btn-elevate btn-pill btn-block">Agregar</button>
        </div>
      </div>
    </div>
    <div class="table-responsive pt-2">
      <table class="table table-sm table-striped">
        <thead>
        <tr>
          <th>Tipo de pasivo</th>
          <th>Observación</th>
          <th class="text-right">Valor</th>
          <th class="text-center">Acción</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(i,ii) in registros" :key="ii" class="animated fadeInDown">
          <td>{{ lstTipoPasivo.find(x => x.id === i[dtoEscritura.tipoId]).dt1 }}</td>
          <td class="texto-prefabricdo">{{ i[dtoEscritura.observacion] }}</td>
          <td class="text-right precio-syb">{{ puntos(i[dtoEscritura.valor]) }}</td>
          <td class="text-center">
            <button type="button" class="btn btn-link btn-sm" v-on:click="eliminar(ii)" title="Eliminar">
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr v-if="registros.length">
          <th colspan="2" class="text-right">Total:</th>
          <td class="text-right precio-syb">{{ puntos(suma(registros)) }}</td>
          <td></td>
        </tr>
        <tr v-if="!registros.length">
          <td colspan="4" class="text-center text-muted">
            No hay elementos agregados<br>
            <span class="text-danger">Agregue elementos con el botón <code>Agregar</code></span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </form>
</template>
<script>
import comboBox from "../comboBox";
import constantes from "../../constantes";

export default {
  name: "pasivos",
  props: {
    previos: {
      type: Array,
      default: function () {
        return [];
      },
    },
    sync: {
      type: Boolean,
      default: false,
    },
    lstTipoPasivo: {
      type: Array,
      required: true
    }
  },
  components:
      {
        comboBox
      },
  data: () => ({
    datos: {
      tipoPasivo: {id: null},
      cantidad: null,
      obs: null,
    },
    etiquetas: [
      "Tipo de Pasivo",
      "Obersvación",
      "Valor",
      "Acción"
    ],
    registros: [],
    dtoLectura: {
      tipoId: 'id',
      observacion: 'dt2',
      valor: 'ndt1',
    },
    dtoEscritura: {
      tipoId: 'ndt2',
      observacion: 'dt1',
      id: 'id',
      valor: 'ndt1',
    },
    validarEntrada: 'ndt1',
  }),
  methods: {
    validarExistencia: function (objeto) {
      const texto = this.lstTipoPasivo.find(x => x.id === objeto.tipoId).dt1;
      const resultado = this.registros.find(item => item[this.dtoEscritura.tipoId] === objeto.tipoId);
      if (resultado) {
        this.$swal({
          title: 'Elemento Repetido',
          html: `<b>Ya Existe un elemento de tipo ${texto}<br>¿Quieres sumarlo?</b>`,
          showLoaderOnConfirm: true,
          showCancelButton: true,
          confirmButtonText: 'Si',
          confirmButtonAriaLabel: 'Si',
          cancelButtonText: 'No',
          cancelButtonAriaLabel: 'No',
          preConfirm: () => {
            this.eliminar(this.registros.findIndex(item => item[this.dtoEscritura.tipoId] === objeto.tipoId));
            objeto.observacion = resultado[this.dtoEscritura.observacion] + '\n' + objeto.observacion;
            objeto.valor = parseFloat(resultado[this.dtoEscritura.valor]) + parseFloat(objeto.valor);
            let aux = {};
            for (const [key] of Object.entries(this.dtoEscritura)) {
              aux[this.dtoEscritura[key]]=objeto[key];
            }
            this.registros.splice(0, 0, aux);
          }
        });
      } else {
        let aux = {};
        for (const [key] of Object.entries(this.dtoEscritura)) {
          aux[this.dtoEscritura[key]]=objeto[key];
        }
        this.registros.splice(0, 0, aux);
      }
    },
    validar: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          const datos = {
            observacion: this.datos.obs,
            tipoId: this.datos.tipoPasivo.id,
            valor: this.datos.cantidad,
          };
          this.datos = {
            tipoPasivo: {id: null},
            cantidad: null
          };
          this.validarExistencia(datos);
        } else {
          this.$toast.show(`Completa el formulario de Pasivos`);
        }
      });
    },
    eliminar(indice) {
      this.registros.splice(indice, 1);
    },
    puntos: (numero) => constantes.funciones.puntoMilesDecimal(parseFloat(numero)),
    suma: function (lista) {
      return constantes.funciones.sumar3(this.dtoEscritura.valor, lista);
    },
    preCargar: function () {
      this.previos.forEach(
          (i) => {
            let aux = {};
            for (const [key, value] of Object.entries(this.dtoLectura)) {
              aux[this.dtoEscritura[key]]=i[value];
            }
            if(aux[this.validarEntrada]>0){
              this.registros.push(aux);
            }
          }
      );
    }
  },
  watch: {
    registros: function (val) {
      this.$emit('input', val);
    },
    previos: function () {
      this.preCargar();
    },
    sync: function () {
      this.preCargar();
    }
  },
}
</script>
<style scoped>

</style>
